import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { RecoilRoot } from "recoil";

import store from "./store";

import "./index.css";
import "./i18n"; // ⭐ 중요: 한번만

const app = (
  <RecoilRoot>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </RecoilRoot>
);

ReactDOM.render(app, document.getElementById("root"));
